const initialState = {
  pageNo: 1,
  totalCount: 0,
  data: [],
  isLoading: false,
  tabsearch: "",
  refresh: "text",
  clickedData: null,
  isGoBack: false,
  isBackFromEmailLink: "false",
  excludeEmail: true,
  nonCurated: false,
  urgent: false,
  curatedBy: [],
  curatedFromDate: "",
  curatedToDate: "",
  status: [],
  rating: [],
  spill: false,
  cs: [],
  cc: [],
  fromDate: "",
  tillDate: "",
  seekers: [],
  seekerType: "",
  experts: [],
  expertsList: [],
  selectedDataDetailed: null,
  detailedRefresh: 0,
  selectedDomainName: null,
  seekerAttachments: [],
  keytags: [],
};

const cmExpertRecordsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "getExpertRecordKeyTag":
      state = { ...state, keytags: payload };
      return state;
    case "cmrTotalCount":
      state = { ...state, totalCount: payload };
      return state;
    case "cmrUpdatePageNo":
      state = { ...state, isLoading: true };
      state = { ...state, pageNo: payload };
      return state;
    case "cmrUpdateData":
      state = { ...state, isLoading: false };
      state = { ...state, data: payload };
      return state;
    case "cmrUpdatePage":
      state = { ...state, isLoading: payload };
      return state;
    case "cmrClickedData":
      state = { ...state, clickedData: payload };
      return state;
    case "cmrRefreshPage":
      state = { ...state, refresh: Math.random() };
      return state;
    case "cmrTabSearchData":
      state = { ...state, tabsearch: payload };
      state = { ...state, pageNo: 1 };
      return state;
    case "cmrUpdateFilters":
      let key = payload?.key;
      let val = payload?.val;
      if (key === "excludeEmail") {
        state = { ...state, excludeEmail: val };
      }
      if (key === "nonCurated") {
        state = { ...state, nonCurated: val };
      }
      if (key === "urgent") {
        state = { ...state, urgent: val };
      }
      if (key === "spill") {
        state = { ...state, spill: val };
      }
      if (key === "rating") {
        state = { ...state, rating: [] };
      }
      if (key === "status") {
        state = { ...state, status: [] };
      }
      if (key === "cs") {
        state = { ...state, cs: [] };
      }
      if (key === "cc") {
        state = { ...state, cc: [] };
      }
      if (key === "seekers") {
        state = { ...state, seekers: [] };
      }
      if (key === "experts") {
        state = { ...state, experts: [] };
      }
      if (key === "seekerType") {
        state = { ...state, seekerType: "" };
      }
      state = { ...state, pageNo: 1 };
      return state;
    case "cmrIsGoBack":
      state = { ...state, isGoBack: payload };
      return state;
    case "cmrIsBackFromEmailLink":
      state = { ...state, isBackFromEmailLink: payload };
      return state;
    case "cmrQuestionsFilter":
      state = { ...state, status: payload.status };
      state = { ...state, rating: payload.rating };
      state = { ...state, cs: payload.cs };
      state = { ...state, cc: payload.cc };
      state = { ...state, spill: payload.spill };
      state = { ...state, pageNo: 1 };
      return state;
    case "cmrTimeFrameFilter":
      state = { ...state, excludeEmail: payload.excludeEmail };
      state = { ...state, nonCurated: payload.isLastUpdate };
      state = { ...state, urgent: payload.express };
      state = { ...state, curatedBy: payload.lastUpdateBy };
      state = { ...state, curatedFromDate: payload.fromDate };
      state = { ...state, curatedToDate: payload.toDate };
      state = { ...state, pageNo: 1 };
      return state;
    case "cmrAskFilter":
      state = { ...state, fromDate: payload.from };
      state = { ...state, tillDate: payload.to };
      state = { ...state, pageNo: 1 };
      return state;
    case "cmrUsersFilter":
      state = { ...state, seekers: payload.seekers };
      state = { ...state, experts: payload.experts };
      state = { ...state, seekerType: payload.seekerType };
      state = { ...state, pageNo: 1 };
      return state;
    case "cmrExpertsList":
      state = { ...state, expertsList: payload };
      return state;
    case "cmrSelectedDataDetailed":
      state = { ...state, selectedDataDetailed: payload };
      return state;
    case "cmrDetailedRefresh":
      state = { ...state, detailedRefresh: Math.random() };
      return state;
    case "selectedDomainNameFromExpertOverview":
      state = { ...state, selectedDomainName: payload };
      return state;
    case "crossnavigationAnswered":
      state = {
        ...initialState,
        excludeEmail: false,
        nonCurated: false,
        pageNo: 1,
        status: { name: "answered", value: "Answered", label: "Answered" },
      };
      return state;
    case "crossnavigationNotAnswered":
      state = {
        ...initialState,
        excludeEmail: false,
        nonCurated: false,
        pageNo: 1,
        spill: true,
      };
      return state;
    case "crossnavigationExpertCuration":
      state = {
        ...initialState,
        excludeEmail: false,
        nonCurated: false,
        experts: payload.email,
        pageNo: 1,
        cc: payload.curation,
      };
      return state;
    case "crossnavigationExpertCurationCurated":
      state = {
        ...initialState,
        excludeEmail: false,
        nonCurated: false,
        pageNo: 1,
        experts: payload.email,
        cs: payload.cs,
      };
    case "getSeekerAttachmentsInExpertRecords":
      state = { ...state, seekerAttachments: payload };
      return state;
    default:
      return state;
  }
};

export default cmExpertRecordsReducer;
